export const errorMessageHandle = error => {
  if (error.response !== undefined) {
    const { data, status } = error.response;
    if (status === 422 && data.errors) {
      let cmessages = "";
      for (var message in data.errors) {
        cmessages = cmessages.concat(data.errors[message]);
      }
      return cmessages;
    }

    return data.msg || data.err || data.error || data.message || error.message;
  }

  return error.message;
};
